export const vehicles = [
  {
    id: 1,
    name: 'Chrysler Pacifica Hybrid',
    year: 2023,
    color: 'Cinza',
    type: 'Minivan',
    passengers: 7,
    transmission: 'Automático',
    fuel: 'Híbrido',
    pricePerDay: 60,
    image: 'https://public.readdy.ai/ai/img_res/188bc18e8dee694c61f3ba8f68d0cdca.jpg',
    badge: 'ECO',
    badgeColor: 'bg-green-500',
    features: ['7 Passageiros', 'Híbrido', 'Automático', 'Ar Condicionado', 'GPS Incluído'],
    description: 'Perfeito para famílias que buscam economia de combustível sem abrir mão do conforto e espaço.'
  },
  {
    id: 2,
    name: 'Chrysler Pacifica',
    year: 2023,
    color: 'Branca',
    type: 'Minivan',
    passengers: 7,
    transmission: 'Automático',
    fuel: 'Gasolina',
    pricePerDay: 60,
    image: 'https://readdy.ai/api/search-image?query=professional%20commercial%20photo%20of%20white%20pearl%20chrysler%20pacifica%20minivan%202023%20model%20in%20pristine%20condition%20parked%20in%20modern%20studio%20with%20clean%20white%20background%20and%20professional%20lighting%20highlighting%20sleek%20design%20three%20quarter%20front%20view%20angle&width=800&height=600&seq=pacifica-white-2023&orientation=landscape',
    badge: 'POPULAR',
    badgeColor: 'bg-blue-600',
    features: ['7 Passageiros', 'Gasolina', 'Automático', 'Ar Condicionado', 'GPS Incluído'],
    description: 'Nossa opção mais popular! Espaçoso, confortável e perfeito para toda a família.'
  },
  {
    id: 3,
    name: 'Honda Odyssey Sport',
    year: 2024,
    color: 'Blue Gray',
    type: 'Minivan',
    passengers: 8,
    transmission: 'Automático',
    fuel: 'Gasolina',
    pricePerDay: 60,
    image: 'https://readdy.ai/api/search-image?query=professional%20commercial%20photo%20of%20blue%20gray%20metallic%20honda%20odyssey%20sport%202024%20model%20newest%20generation%20parked%20in%20modern%20studio%20with%20clean%20white%20background%20and%20dramatic%20lighting%20showcasing%20sporty%20design%20and%20premium%20features%20three%20quarter%20front%20view&width=800&height=600&seq=odyssey-sport-2024&orientation=landscape',
    badge: 'NOVO 2024',
    badgeColor: 'bg-orange-500',
    features: ['8 Passageiros', 'Gasolina', 'Automático', 'Ar Condicionado', 'GPS Incluído'],
    description: 'Nosso modelo mais novo! Tecnologia de ponta e máximo conforto para sua família.'
  },
  {
    id: 4,
    name: 'Mitsubishi Outlander',
    year: 2019,
    color: 'Preto',
    type: 'SUV',
    passengers: 7,
    transmission: 'Automático',
    fuel: 'Gasolina',
    pricePerDay: 55,
    image: 'https://readdy.ai/api/search-image?query=professional%20commercial%20photo%20of%20black%20mitsubishi%20outlander%20suv%202019%20model%20in%20excellent%20condition%20parked%20in%20modern%20studio%20with%20clean%20white%20background%20and%20professional%20lighting%20highlighting%20sleek%20black%20finish%20three%20quarter%20front%20view%20angle&width=800&height=600&seq=outlander-black-2019&orientation=landscape',
    badge: 'ECONÔMICO',
    badgeColor: 'bg-gray-600',
    features: ['7 Passageiros', 'SUV', 'Automático', 'Ar Condicionado', 'GPS Incluído'],
    description: 'Perfeito para famílias que buscam economia sem abrir mão do espaço e conforto.'
  }
];

export const testimonials = [
  {
    name: 'Carolina Caetano',
    location: 'Macaé, RJ',
    text: 'Experiência incrível! O carro estava impecável e o atendimento foi excepcional. Recomendo muito para quem vai para Orlando com a família. Sem contar o cuidado com tudo em relação a nossa chegada e saída pelo aeroporto. Obrigado DWUS!',
    rating: 5,
    avatar: 'https://static.readdy.ai/image/5c0ad1e95b49fc3621673298b03cd410/3d18ce413d48a4fdf03c89a5edf415b5.jpeg'
  },
  {
    id: 2,
    name: 'Marci Monzato',
    location: 'Rio das Ostras, RJ',
    rating: 5,
    text: 'Melhor custo-benefício de Orlando! Alugamos a Pacifica Hybrid e economizamos muito em combustível. Voltaremos com certeza!',
    avatar: 'https://static.readdy.ai/image/5c0ad1e95b49fc3621673298b03cd410/73e1c47ce9f91948a7394326f502fd08.jpeg'
  },
  {
    id: 3,
    name: 'Chis Senna',
    location: 'Cabo Frio, RJ',
    rating: 5,
    text: 'Atendimento em português fez toda diferença. Pegamos a van no aeroporto e devolvemos no hotel. Tudo muito prático! Sem estresse e sem burocracias!',
    avatar: 'https://static.readdy.ai/image/5c0ad1e95b49fc3621673298b03cd410/cab95b435308de5ee51d3dec9185c930.jpeg'
  },
  {
    id: 4,
    name: 'Alvinho',
    location: 'Sao Paulo, Brasil',
    rating: 5,
    text: 'Van espaçosa e confortável. Conseguimos levar todas as malas e compras da Disney sem problemas. Excelente! Vamos voltar e fechar com a DWUS com certeza!',
    avatar: 'https://i.pravatar.cc/150?img=13'
  },
  {
    id: 5,
    name: 'Fernanda Lima',
    location: 'Curitiba, Brasil',
    rating: 5,
    text: 'Suporte 24h salvou nossa viagem! Tivemos uma dúvida tarde da noite e fomos atendidos prontamente. Profissionais!',
    avatar: 'https://i.pravatar.cc/150?img=9'
  }
];

export const benefits = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: 'Seguro Completo Incluído',
    description: 'Cobertura total sem taxas ocultas. Viaje tranquilo sabendo que você e sua família estão protegidos.'
  },
  {
    id: 2,
    icon: 'ri-map-pin-line',
    title: 'Entrega e Retirada Flexível',
    description: 'Buscamos e entregamos no aeroporto, hotéis ou residências. Máxima comodidade para você.*',
    disclaimer: 'Taxas podem ser aplicadas.'
  },
  {
    id: 3,
    icon: 'ri-customer-service-2-line',
    title: 'Suporte 24/7 em Português',
    description: 'Assistência completa durante toda sua viagem. Estamos sempre disponíveis para ajudar.'
  }
];
